module.exports = __webpack_public_path__ + "static/media/bicomb.5df8eacb.jpg";